import clsx from "clsx";

import { PrimaryButton, TertiaryButton } from "@shared/buttons";
import { Modal } from "@shared/modal";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const ExitEditorComfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
}: Props) => {
  return (
    <Modal
      isOpen={isOpen}
      titleContent={
        <h3
          className={clsx(
            "heading mx-0 mb-0 mt-0 font-bold text-[1.5rem] max-w-[500px]",
            "leading-8",
          )}
        >
          Exit without saving your breakdown?
        </h3>
      }
      onClose={onClose}
    >
      <div className="mt-3 mb-5">All your changes will be lost!</div>
      <div className="flex items-center justify-end gap-2">
        <TertiaryButton className="ml-2 font-bold" onClick={onClose}>
          CANCEL
        </TertiaryButton>
        <PrimaryButton
          className={clsx("font-bold flex items-center gap-2")}
          onClick={onConfirm}
        >
          YES, CONTINUE
        </PrimaryButton>
      </div>
    </Modal>
  );
};
